import AdditionalCriterion from './AdditionalCriterion';
import { BaseModel } from './BaseModel';
import LearningOutcome from './LearningOutcome';
// import Post from "./Post";

export class Criteria extends BaseModel {
  static get entity() {
    return 'criterias';
  }

  static get fk() {
    return 'criterion_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      title: this.attr(null),
      description: this.attr(null),
      pass_title: this.attr(null),
      not_yet_title: this.attr(null),
      pass_criterion: this.attr(null),
      not_yet_criterion: this.attr(null),
      learning_outcome_id: this.attr(null),
      learning_outcome: this.belongsTo(LearningOutcome, 'learning_outcome_id'),
      additional_criterion_ids: this.attr([]),
      additional_criteria: this.hasManyBy(AdditionalCriterion, 'additional_criterion_ids'),
      // post_ids: this.attr([]),
      // posts: this.hasManyBy(Post, "post_ids"),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      fetch(params) {
        return this.get(`/criteria`, { params });
      },

      fetchById(id) {
        return this.get(`/criteria/${id}`);
      },

      create(body) {
        return this.post(`/criteria`, body);
      },

      update(id, body) {
        return this.put(`/criteria/${id}`, body);
      },

      destroy(id) {
        return this.delete(`/criteria/${id}`, {
          delete: id
        });
      }
    }
  };
}

export default Criteria;
